<script>
	import List from "../List/List.svelte";
	import Separator from "../../library/Separator.svelte";

	export let api;
	export let state;
	export let store;
	export let data;
	export let level = 0;
	export let id;

	const rShape = state.taskShape;
	$: isHideCompleted = $rShape?.completed?.taskHide;

</script>

<ul
	class="wx-todo_tree"
	class:wx-todo_tree--root={!level}
	data-todo-wrapper-id={id}>
	{#each data as task (task.id)}
		{#if !(isHideCompleted && task.checked)}
			<li class="wx-todo_tree__row">
				<List on:action {store} {api} {task} level={level + 1} />
				<slot />
				{#if task.children.length && !task.collapsed}
					<svelte:self
						on:action
						{state}
						{store}
						{api}
						level={level + 1}
						data={task.children} />
				{/if}
				{#if level === 0}
					<Separator />
				{/if}
			</li>
		{/if}
	{/each}
</ul>

<style>
	.wx-todo_tree {
		display: flex;
		flex-direction: column;
		height: 100%;
		width: 100%;
		margin: 0;
		padding: 0;
	}
	.wx-todo_tree--root {
		overflow-y: auto;
	}
	:global(.wx-ondrag--touch) .wx-todo_tree {
		overflow-y: hidden;
		user-select: none;
	}
	.wx-todo_tree__row {
		display: flex;
		flex-direction: column;
	}

</style>
